import React from "react";
import SectionTitle from "../common/SectionTitle";
import { useFormSection, FormSectionProps } from "../../hooks/useFormSection";
import { useIntakeFormStore } from "../../stores/intakeFormStore";
import { symptomConfig } from "../../lib/data/symptomConfig";
import SymptomGroup from "./symptom-burden/SymptomGroup";
import CheckboxGroup from "./symptom-burden/CheckboxGroup";

interface SymptomBurdenSectionProps extends FormSectionProps {
  gender?: string;
}

const SymptomBurdenSectionV2: React.FC<SymptomBurdenSectionProps> = (props) => {
  const { Field, formData, isEditMode = true } = useFormSection(props);
  const gender = props.gender || formData?.personalInfo?.gender || "";
  const symptomData = formData?.symptomAssessment || {};

  // Custom handler for symptom groups since they use nested structure
  const handleSymptomChange = (path: string, value: unknown) => {
    const store = useIntakeFormStore.getState();
    store.updateField(path, value);
  };

  return (
    <section>
      <SectionTitle>Symptomatology Assessment</SectionTitle>
      <p className="mb-6 text-brand-stone-600">
        Please indicate frequency of issue or symptoms: 0 = Never / 1 = Rarely occurs / 2 = Moderate (Frequently occurs) / 3 = Severe (Daily or weekly)
      </p>

      {Object.entries(symptomConfig).map(([key, config]) => {
        if (config.gender && config.gender !== gender && gender !== "other") {
          return null;
        }

        return (
          <React.Fragment key={key}>
            <SymptomGroup
              {...config}
              sectionKey={key}
              data={symptomData}
              handleChange={handleSymptomChange}
              disabled={!isEditMode}
            />
            
            {config.checkboxes && (
              <CheckboxGroup
                {...config.checkboxes}
                sectionKey={`${key}Conditions`}
                data={symptomData}
                handleChange={handleSymptomChange}
                disabled={!isEditMode}
              />
            )}
            
            {config.autoimmune && (
              <CheckboxGroup
                {...config.autoimmune}
                sectionKey="autoimmuneConditions"
                data={symptomData}
                handleChange={handleSymptomChange}
                disabled={!isEditMode}
              />
            )}
            
            {config.additionalFields?.map((field) => (
              <div key={field.key} className="mb-4">
                <Field
                  path={`symptomAssessment.${key}.${field.key}`}
                  label={field.label}
                  type="text"
                  className="w-full md:w-1/2"
                />
              </div>
            ))}
          </React.Fragment>
        );
      })}
    </section>
  );
};

export default SymptomBurdenSectionV2;